
<div identity="c-card-options-wrap">
  <cvt-collapse
    :accordion="true"
    :theme="mode === 'LIGHT' ? 'light' : 'dark'"
    :prepend-chevron="prependChevron"
  >
    <cvt-collapse-item
      v-if="containerItemSettings.isWrappedByCContainerItem"
      title="Container Item Options"
      :special-style="isSpecialStyle"
    >
      <c-container-item-options :mode="mode" />
    </cvt-collapse-item>
    <cvt-collapse-item
      name="build"
      :title="$t('elements.property.configurations.label')"
      :special-style="isSpecialStyle"
    >
      <div class="row mb-3">
        <!-- View Controls -->
        <div class="col-12">
          <cvt-field-label :mode="mode" label="Direction" />
          <cvt-radio-group
            orientation="horizontal"
            :theme="mode"
            :initial-value="flexDirection"
          >
            <el-tooltip
              v-for="item in direction"
              :key="item.value"
              :content="item.value"
              placement="top"
            >
              <cvt-radio-button
                size="md"
                :value="item.value"
                @radioClick="() => (flexDirection = item.value)"
              >
                <cvt-icon :icon="item.icon" style="font-size: 18px" />
              </cvt-radio-button>
            </el-tooltip>
          </cvt-radio-group>
        </div>
      </div>

      <div class="divider mt-2" />

      <div class="row mb-3">
        <!-- Card Wrap Properties -->
        <div class="col-12">
          <cvt-field-label :mode="mode" label="Wrap" />
          <cvt-radio-group
            orientation="horizontal"
            :theme="mode"
            :initial-value="flexWrap"
          >
            <el-tooltip
              v-for="item in layoutWrapOption"
              :key="item.value"
              :content="item.value"
              placement="top"
            >
              <cvt-radio-button
                size="md"
                :value="item.value"
                @radioClick="() => (flexWrap = item.value)"
              >
                <cvt-icon :icon="item.icon" style="font-size: 18px" />
              </cvt-radio-button>
            </el-tooltip>
          </cvt-radio-group>
        </div>
      </div>
      <div class="divider mt-2" />
      <div class="row mb-3">
        <!-- Justify Content Spacing Properties -->
        <div class="col-12">
          <cvt-field-label :mode="mode" label="Justify Content" />
          <cvt-radio-group
            orientation="horizontal"
            :theme="mode"
            :initial-value="justifyContent"
          >
            <el-tooltip
              v-for="item in SpacingOption.slice(0, 5)"
              :key="item.value"
              :content="`${item.value}`"
              placement="top"
            >
              <cvt-radio-button
                size="md"
                :value="item.value"
                @radioClick="() => (justifyContent = item.value)"
              >
                <cvt-icon :icon="item.icon" style="font-size: 18px" />
              </cvt-radio-button>
            </el-tooltip>
          </cvt-radio-group>

          <cvt-radio-group
            orientation="horizontal"
            :theme="mode"
            :initial-value="justifyContent"
          >
            <el-tooltip
              v-for="item in SpacingOption.slice(5, 10)"
              :key="item.value"
              :content="`${item.value}`"
              placement="top"
            >
              <cvt-radio-button
                size="md"
                :value="item.value"
                @radioClick="() => (justifyContent = item.value)"
              >
                <cvt-icon :icon="item.icon" style="font-size: 18px" />
              </cvt-radio-button>
            </el-tooltip>
          </cvt-radio-group>
        </div>
      </div>
      <div class="divider mt-2" />
      <div class="row mb-3">
        <!-- Align Items Spacing Properties -->
        <div class="col-12">
          <cvt-field-label :mode="mode" label="Align Items" />
          <cvt-radio-group
            orientation="horizontal"
            :theme="mode"
            :initial-value="alignItems"
          >
            <el-tooltip
              v-for="item in SpacingOption.slice(0, 5)"
              :key="item.value"
              :content="`${item.value}`"
              placement="top"
            >
              <cvt-radio-button
                size="md"
                :value="item.value"
                @radioClick="() => (alignItems = item.value)"
              >
                <cvt-icon :icon="item.icon" style="font-size: 18px" />
              </cvt-radio-button>
            </el-tooltip>
          </cvt-radio-group>

          <cvt-radio-group
            orientation="horizontal"
            :theme="mode"
            :initial-value="alignItems"
          >
            <el-tooltip
              v-for="item in SpacingOption.slice(5, 10)"
              :key="item.value"
              :content="`${item.value}`"
              placement="top"
            >
              <cvt-radio-button
                size="md"
                :value="item.value"
                @radioClick="() => (alignItems = item.value)"
              >
                <cvt-icon :icon="item.icon" style="font-size: 18px" />
              </cvt-radio-button>
            </el-tooltip>
          </cvt-radio-group>
        </div>
      </div>
      <div class="divider mt-2" />

      <div class="row">
        <div class="col-md-12 mb-3 d-flex align-items-center text-capitalize">
          Horizontal Gap
        </div>
        <div class="col-12">
          <cvt-slider
            id="slider-default"
            :tooltips-enabled="true"
            :step-marks-enabled="true"
            class="slider"
            :min="1"
            :max="100"
            :value="horizontalGap"
            :step="1"
            @change="(value) => (horizontalGap = value)"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12 mb-3 d-flex align-items-center text-capitalize">
          Vertical Gap
        </div>
        <div class="col-12">
          <cvt-slider
            id="slider-default"
            :tooltips-enabled="true"
            :step-marks-enabled="true"
            class="slider"
            :min="1"
            :max="100"
            :value="verticalGap"
            :step="1"
            @change="(value) => (verticalGap = value)"
          />
        </div>
      </div>
      <div class="divider mt-3" />

      <!-- Padding Control -->
      <div class="row mt-3">
        <div class="col-12 d-flex align-items-center justify-content-between mb-3">
          <span class="text-capitalize">Padding</span>
          <div class="d-flex align-items-center">
            <cvt-select
              mode="dropdown"
              :value="paddingUnit"
              :background-mode="mode"
              style="width: 80px"
              @input="(value) => (paddingUnit = value)"
            >
              <option
                v-for="unit in paddingUnits"
                :key="unit"
                :value="unit"
                v-text="unit"
              />
            </cvt-select>
            <el-tooltip
              :content="paddingLocked ? 'Unlock padding sides' : 'Lock padding sides'"
              placement="top"
            >
              <button
                class="btn btn-sm ml-2 padding-lock-btn"
                :class="{ 'locked': paddingLocked }"
                @click="paddingLocked = !paddingLocked"
              >
                <cvt-icon :icon="paddingLocked ? 'lock' : 'lock-open'" />
              </button>
            </el-tooltip>
          </div>
        </div>
        
        <div class="col-12">
          <div class="padding-inputs-grid">
            <!-- Top -->
            <div class="padding-input-group">
              <label class="padding-label">Top</label>
              <cvt-input
                type="number"
                :value="paddingTop"
                :clearable="false"
                @blur="onPaddingTopChange"
              />
            </div>
            
            <!-- Right -->
            <div class="padding-input-group">
              <label class="padding-label">Right</label>
              <cvt-input
                type="number"
                :value="paddingRight"
                :disabled="paddingLocked"
                :clearable="false"
                @blur="(value) => (paddingRight = value.target.value)"
              />
            </div>
            
            <!-- Bottom -->
            <div class="padding-input-group">
              <label class="padding-label">Bottom</label>
              <cvt-input
                type="number"
                :value="paddingBottom"
                :disabled="paddingLocked"
                :clearable="false"
                @blur="(value) => (paddingBottom = value.target.value)"
              />
            </div>
            
            <!-- Left -->
            <div class="padding-input-group">
              <label class="padding-label">Left</label>
              <cvt-input
                type="number"
                :value="paddingLeft"
                :disabled="paddingLocked"
                :clearable="false"
                @blur="(value) => (paddingLeft = value.target.value)"
              />
            </div>
          </div>
        </div>
      </div>
    </cvt-collapse-item>

    <cvt-collapse-item
      name="manage_list"
      :title="`Manage Items`"
      :initial-active="true"
      :special-style="isSpecialStyle"
    >
      <div class="row">
        <div class="col">
          <div class="form-fields">
            <div class="row">
              <div class="col-md-12">
                <draggable-list
                  :list="cardItems"
                  @change="updateCardFields"
                  @item-clicked="selectField"
                >
                  <template slot="list-item-template" slot-scope="props">
                    <cvt-icon
                      id="drag-handle"
                      :icon="iconConfig.leftSidebar.layout.drag || 'copy'"
                    />
                    <span :class="{ 'blue-text': false }">
                      {{ fmtFieldName(props.item, props.index) }}
                    </span>
                  </template>
                </draggable-list>

                <ElementSelector
                  :mode="mode"
                  @element-selected="addCardField"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </cvt-collapse-item>

    <cvt-collapse-item
      :title="$t('elements.properties.global.style.label.container')"
      name="container_style"
    >
      <c-card-container-style-option :mode="mode" />
    </cvt-collapse-item>
  </cvt-collapse>
</div>
